import { vaultPostRequest } from '../helpers';
import type { IRenameClipFilesRequest } from './rename-clip-files-request';
import type { IRenameClipFilesResponse } from './rename-clip-files-response';
import { renameClipFilesResponseSchema } from './rename-clip-files-response';

export async function renameClipFilesApi(
  body: IRenameClipFilesRequest,
): Promise<IRenameClipFilesResponse> {
  return vaultPostRequest({
    path: '/crop/rename-clip',
    body,
    schema: renameClipFilesResponseSchema,
  });
}
